/**
 * Thin client for sliding_tiles_gm session APIs (Option B).
 * Wire uses EMPTY=999; FE uses null.
 */
import { API_PATH_PROXY_ENABLED, ARCADE } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'sliding_tiles_puzzle';

export const TILES_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.sliding_tiles_puzzle?.API_BASE || '')
    : '/tiles';

export const GM_EMPTY = 999;

export function fromGmBoard(puzzle) {
    if (!Array.isArray(puzzle)) return [];
    return puzzle.map((t) => (t === GM_EMPTY || t === 999 ? null : t));
}

export function toGmBoard(puzzle) {
    if (!Array.isArray(puzzle)) return [];
    return puzzle.map((t) => (t == null ? GM_EMPTY : t));
}

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Tiles GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createTilesSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${TILES_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function inputTilesSession(sessionId, position) {
    const res = await fetch(`${TILES_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ position }),
    });
    return parseJson(res);
}

export async function deleteTilesSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${TILES_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}
